export default "__VITE_ASSET__fcjnwCFk__"